import React from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
  Badge,
  Button
} from "reactstrap";
import { FaRegBuilding } from "react-icons/fa6";   // ticket icon
import { FiEdit2 } from "react-icons/fi"; 
import { IoTicketSharp } from "react-icons/io5";
import './Supporttickets.css'
function Previous_support_card() {
  const borderClr   = "#E5E7EB";     // light grey border / dashed lines
  const labelClr    = "#6B7280";     // grey label text
  const valueClr    = "#111827";     // dark value text
  const headlineClr = "#555555";     // top title text

  return (
    <Card
      style={{
        border: `1px solid ${borderClr}`,
        borderRadius: "16px",
        overflow: "hidden",
        

      }}
    >
      <CardBody>
        {/* ─────────── Header ─────────── */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "1rem",
          }}
        >
          {/* circle icon */}
          <div
            style={{
              height: 32,
              width: 32,
              borderRadius: "50%",
              backgroundColor: "#E5EEF8",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: 12,
            }}
          >
            <IoTicketSharp size={18} color="#091954" />
          </div>

          {/* title + status badge */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexGrow: 1,
              minWidth: 0,
              flex:"wrap"
            }}
          >
            <h5
              style={{
                fontSize: 18,
                fontWeight: 600,
                color: headlineClr,
                margin: 0,
                
              }}
            >
              Ticket# 81&nbsp;ICF
            </h5>
            <Badge
              color="light"
              style={{
                backgroundColor: "#E5EEF8",
                color: "#475569",
                fontWeight: 600,
                fontSize: 12,
                marginLeft: 8,
              }}
            >
              Pending
            </Badge>
          </div>

          {/* edit link */}
          <Button
            color="link"
            style={{ padding: 0, fontSize: 14, fontWeight: 600,color:"#091954" }}
          >
            Edit&nbsp;
            <FiEdit2 size={14} />
          </Button>
        </div>

        <hr style={{ border: "none", borderTop: "1px solid #BEBEBE" }} />

        {/* ─────────── Details ─────────── */}
        <section style={{ }}>
          <h6 style={{ fontWeight: 700, marginBottom: 12 ,color:"#555555" }}>Details:</h6>

          {/* Module */}
          <div style={{ display: "flex", marginBottom: 8 }}>
            <span style={{ width: 80, color: labelClr }}>Module:</span>
            <Badge
              className="bdg"
              color="light"
              style={{ color: "#091954", fontWeight: 600, fontSize: 12 }}
            >
              Helmet
            </Badge>
          </div>

          {/* Generated by */}
          <div style={{ display: "flex", marginBottom: 8 }}>
            <span style={{ width: 80, color: labelClr }}>Generated&nbsp;by:</span>
            <span style={{ color: valueClr ,fontWeight:"400" }}>Ameer&nbsp;Hamza</span>
          </div>

          {/* Issue Date */}
          <div style={{ display: "flex" }}>
            <span style={{ width: 80, color: labelClr }}>Issue&nbsp;Date:</span>
            <span style={{ color: valueClr ,fontWeight:"400"}}>29/12/2024,&nbsp;15:08:46</span>
          </div>
        </section>

        <hr
  style={{bordernone: "none", borderTop: "2px dashed  #BEBEBE"}}

/>

        {/* ─────────── Area ─────────── */}
        <section style={{ padding: "" }}>
          <div style={{ display: "flex", marginBottom: 8 }}>
            <span style={{ width: 80, color: labelClr }}>Area:</span>
            <span style={{ color: valueClr  ,fontWeight:"400"}}>AO‑6</span>
          </div>
          <div style={{ display: "flex" }}>
            <span style={{ width: 80, color: labelClr }}>Sub&nbsp;Area:</span>
            <span style={{ color: valueClr }}>Dry Store&nbsp;1,&nbsp;2</span>
          </div>
        </section>

        <hr
  style={{bordernone: "none", borderTop: "2px dashed  #BEBEBE"}}

/>

        {/* ─────────── Priority ─────────── */}
        <section style={{ padding: "" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <span style={{ width: 80, color: labelClr }}>Priority:</span>
            <span style={{ color: valueClr, display: "flex", alignItems: "center" }}>
              High
              <span
                style={{
                  width: 24,
                  height: 4,
                  backgroundColor: "#DC2626",
                  borderRadius: 2,
                  display: "inline-block",
                  marginLeft: 6,
                }}
              />
            </span>
          </div>
        </section>

         <hr
  style={{bordernone: "none", borderTop: "2px dashed  #BEBEBE"}}

/>

        {/* ─────────── Query ─────────── */}
        <section style={{ paddingTop: "1.5rem" }}>
          <h6 style={{ fontWeight: 700, marginBottom: 8 , color:"#555555" }}>Query:</h6>
          <p style={{ marginBottom: 0, color: valueClr ,fontWeight:"400" }}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </p>
        </section>
      </CardBody>
    </Card>
  );
}

export default Previous_support_card